import apiInstance from '../axios.js';

// 직원 계정 2차 인증(SPEC-SENDCERT-001 design.md §5-3, §6-2 B1')
export const accountSecurityApi = {
  // isCompanyManager·mfa.companyRequired
  async getProfile() {
    return (await apiInstance.get('/auth/profile')).data;
  },
  // 2차 인증 초기화: 직원의 휴대폰·이메일 수단을 지움(휴대폰 분실 등)
  async resetTwoFactor(accountId) {
    return (await apiInstance.delete(`/accounts/${accountId}/two-factor`)).data;
  },
};
